import React, { useEffect, useState } from "react";
import { Card, Descriptions, Spin, Typography, message } from "antd";
import {
  getPathaoStores,
  getPathaoCities,
  getPathaoZones,
  getPathaoAreas,
} from "../../../../actions/Courier/pathaoAction";

const { Title } = Typography;

const PathaoPanel = () => {
  const [loading, setLoading] = useState(false);
  const [store, setStore] = useState(null);
  const [cityName, setCityName] = useState("");
  const [zoneName, setZoneName] = useState("");
  const [areaName, setAreaName] = useState("");

  useEffect(() => {
    const fetchStoreDetails = async () => {
      setLoading(true);
      try {
        // 1️⃣ Fetch stores
        const storeData = await getPathaoStores();

        const selectedStore = Array.isArray(storeData)
          ? storeData.find((s) => s.store_id === 148944)
          : null;

        if (!selectedStore) {
          message.warning("Store with ID 148944 not found.");
          setLoading(false);
          return;
        }

        setStore(selectedStore);

        // 2️⃣ Fetch city, zone, area
        const [cities, zones, areas] = await Promise.all([
          getPathaoCities(),
          getPathaoZones(selectedStore.city_id),
          getPathaoAreas(selectedStore.zone_id),
        ]);

        // 3️⃣ Match IDs
        const city =
          Array.isArray(cities) &&
          cities.find((c) => c.city_id === selectedStore.city_id);
        const zone =
          Array.isArray(zones) &&
          zones.find((z) => z.zone_id === selectedStore.zone_id);
        const area =
          Array.isArray(areas) &&
          areas.find((a) => a.zone_id === selectedStore.zone_id);

        setCityName(
          city && city.city_name
            ? city.city_name
            : "City ID " + selectedStore.city_id
        );
        setZoneName(
          zone && zone.zone_name
            ? zone.zone_name
            : "Zone ID " + selectedStore.zone_id
        );
        setAreaName(area && area.area_name ? area.area_name : "-");
      } catch (error) {
        console.error("Failed to load Pathao data:", error);
        message.error("Failed to load Pathao store details.");
      } finally {
        setLoading(false);
      }
    };

    fetchStoreDetails();
  }, []);

  return (
    <Card style={{ margin: 20, borderRadius: 10 }}>
      <Title level={4}>Pathao Courier Store Details</Title>

      <Spin spinning={loading}>
        {store ? (
          <Descriptions
            bordered
            column={1}
            size="middle"
            labelStyle={{ fontWeight: 600 }}
            style={{ marginTop: 20 }}
          >
            <Descriptions.Item label="Store ID">
              {store.store_id}
            </Descriptions.Item>
            <Descriptions.Item label="Store Name">
              {store.store_name}
            </Descriptions.Item>
            <Descriptions.Item label="Address">
              {store.store_address}
            </Descriptions.Item>
            <Descriptions.Item label="City">
              {cityName}
            </Descriptions.Item>
            <Descriptions.Item label="Zone">
              {zoneName}
            </Descriptions.Item>
            {/* <Descriptions.Item label="Area">
              {areaName}
            </Descriptions.Item> */}
            <Descriptions.Item label="Hub ID">
              {store.hub_id}
            </Descriptions.Item>
            <Descriptions.Item label="Active Status">
              {store.is_active ? "Active" : "Inactive"}
            </Descriptions.Item>
            <Descriptions.Item label="Default Store">
              {store.is_default_store ? "Yes" : "No"}
            </Descriptions.Item>
            <Descriptions.Item label="Default Return Store">
              {store.is_default_return_store ? "Yes" : "No"}
            </Descriptions.Item>
          </Descriptions>
        ) : (
          !loading && (
            <p style={{ marginTop: 20, color: "#999" }}>
              No store details available for ID 148944.
            </p>
          )
        )}
      </Spin>
    </Card>
  );
};

export default PathaoPanel;


// import React, { useEffect, useState } from "react";
// import { Card, Select, Table, Row, Col, Spin, Typography } from "antd";
// import {
//   getPathaoCities,
//   getPathaoZones,
//   getPathaoAreas,
//   getPathaoStores,
// } from "../../../../actions/Courier/pathaoAction";

// const { Option } = Select;
// const { Title } = Typography;

// const PathaoPanel = () => {
//   const [loading, setLoading] = useState(false);
//   const [cities, setCities] = useState([]);
//   console.log(cities)
//   const [zones, setZones] = useState([]);
//   const [areas, setAreas] = useState([]);
//   const [stores, setStores] = useState([]);
//   // console.log(stores)

//   const [selectedCity, setSelectedCity] = useState(null);
//   const [selectedZone, setSelectedZone] = useState(null);
//   const [selectedArea, setSelectedArea] = useState(null);

//   // ✅ Load Cities and Stores initially
// useEffect(() => {
//   const fetchInitialData = async () => {
//     setLoading(true);
//     try {
//       const [cityData, storeData] = await Promise.all([
//         getPathaoCities(),
//         getPathaoStores(),
//       ]);
//       console.log("Fetched City Data:", cityData);
//       setCities(Array.isArray(cityData) ? cityData : []);
//       setStores(Array.isArray(storeData) ? storeData : []);
//     } finally {
//       setLoading(false);
//     }
//   };
//   fetchInitialData();
// }, []);

//   const handleCityChange = async (cityId) => {
//     setSelectedCity(cityId);
//     setSelectedZone(null);
//     setSelectedArea(null);
//     setZones([]);
//     setAreas([]);

//     setLoading(true);
//     const zoneData = await getPathaoZones(cityId);
//     setZones(zoneData || []);
//     setLoading(false);
//   };

//   const handleZoneChange = async (zoneId) => {
//     setSelectedZone(zoneId);
//     setSelectedArea(null);
//     setAreas([]);

//     setLoading(true);
//     const areaData = await getPathaoAreas(zoneId);
//     setAreas(areaData || []);
//     setLoading(false);
//   };

//   const handleAreaChange = (areaId) => {
//     setSelectedArea(areaId);
//   };

//   const storeColumns = [
//     { title: "Store ID", dataIndex: "id", key: "id" },
//     { title: "Store Name", dataIndex: "name", key: "name" },
//     { title: "Contact", dataIndex: "contact_name", key: "contact_name" },
//     { title: "Phone", dataIndex: "contact_number", key: "contact_number" },
//     { title: "Address", dataIndex: "address", key: "address" },
//   ];

//   return (
//     <Card style={{ margin: 20, borderRadius: 10 }}>
//       <Title level={4}>Pathao Courier Configuration</Title>

//       <Row gutter={[16, 16]} style={{ marginBottom: 20 }}>
//         <Col xs={24} md={8}>
//           <label><b>City</b></label>
//             <Select
//             showSearch
//             placeholder="Select City"
//             style={{ width: "100%" }}
//             onChange={handleCityChange}
//             value={selectedCity}
//             loading={loading}
//             >
//             {Array.isArray(cities) &&
//                 cities.map((city) => (
//                 <Option key={city.city_id} value={city.city_id}>
//                     {city.city_name}
//                 </Option>
//                 ))}
//             </Select>
//         </Col>

//         <Col xs={24} md={8}>
//           <label><b>Zone</b></label>
//           <Select
//           showSearch
//             placeholder="Select Zone"
//             style={{ width: "100%" }}
//             onChange={handleZoneChange}
//             value={selectedZone}
//             disabled={!selectedCity}
//           >
//             {zones.map((zone) => (
//               <Option key={zone.zone_id} value={zone.zone_id}>
//                 {zone.zone_name}
//               </Option>
//             ))}
//           </Select>
//         </Col>

//         <Col xs={24} md={8}>
//           <label><b>Area</b></label>
//           <Select
//           showSearch
//             placeholder="Select Area"
//             style={{ width: "100%" }}
//             onChange={handleAreaChange}
//             value={selectedArea}
//             disabled={!selectedZone}
//           >
//             {areas.map((area) => (
//               <Option key={area.area_id} value={area.area_id}>
//                 {area.area_name}
//               </Option>
//             ))}
//           </Select>
//         </Col>
//       </Row>

//       <Spin spinning={loading}>
//         <Title level={5} style={{ marginTop: 20 }}>
//           Available Pathao Stores
//         </Title>
//         <Table
//           dataSource={stores || []}
//           columns={storeColumns}
//           rowKey="id"
//           bordered
//           pagination={false}
//         />
//       </Spin>
//     </Card>
//   );
// };

// export default PathaoPanel;
